import {STUDENT_MARITAL_STATUS_MARRIED} from "../constants/MAGIC_NUMBERS";

export const tableB1a = (form) => {
    const medicareHIRateConstants = {
        'notMarried': {
            'incomeSplit': 200000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        },
        'marriedJoint': {
            'incomeSplit': 250000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        },
        'marriedSeparate': {
            'incomeSplit': 250000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        }
    };

    let rateSource = (parseInt(form.step3.studentMaritalStatus) === STUDENT_MARITAL_STATUS_MARRIED)
        ? medicareHIRateConstants.marriedJoint
        : medicareHIRateConstants.notMarried;

    let income = parseInt(form.step3.studentAdjustedGrossIncome);
    let lower, higher = 0;

    if(income > rateSource.incomeSplit) {
        lower = rateSource.incomeSplit * rateSource.rateUpto;
        higher = (income - rateSource.incomeSplit) * rateSource.rateOver;
    } else {
        lower = income * rateSource.rateUpto;
    }

    return Math.round(lower + higher);
}

export const tableB1b = (form) => {
    const OASDIConstants = {
        'single': {
            'incomeMax': 147000,
            'percent': 0.062,
            'maximum': 9114
        },
        'married': {
            'incomeMax': 294000,
            'percent': 0.062,
            'maximum': 18228
        },
    };

    let dataSource = (parseInt(form.step3.studentMaritalStatus) === STUDENT_MARITAL_STATUS_MARRIED)
        ? OASDIConstants.married
        : OASDIConstants.single;

    let income =
        parseInt(form.step3.studentAdjustedGrossIncome) +
        parseInt(form.step3.studentOtherIncome);

    if(income > dataSource.incomeMax){
        return dataSource.maximum;
    }

    return Math.round(dataSource.percent * income);
}

export const tableB2 = (value) => {

    let startValue = Math.round(value);

    if(startValue < 1) {
        return 0;
    }

    if(startValue <= 165000) {
        return  Math.round(0.4 * startValue);
    }

    if(startValue <= 490000) {
        return 66000 + Math.round(0.5 * startValue - 165000);
    }

    if(startValue <= 820000) {
        return 228500 + Math.round(0.6 * startValue - 490000);
    }

    return 426500 + Math.round(startValue - 820000)
}

export const tableB3 = (form) => {
    return 0;
}